export const blockIconsImageRemoveRedEye = (
	<span className='material-symbols-outlined'>remove_red_eye</span>
);
